import { FC, useMemo, useState } from 'react';
import AssociatedItemsTable from './AssociatedItemsTable';
import { TAssociatedItem, THandleOpenAssociationDialog, TTag } from '../types';
import { Body1, Button } from '@fluentui/react-components';
import { SHOW_ASSOCIATED_FILES_DEFAULT_NUM } from '../constants';
import AssociateButton from './AssociateButton';
import TagBadge from './TagBadge';
import { getJurisdictionId, TJurisdictionMap } from '@modules/items';

type TProps = {
  tag: TTag;
  jurisdictionsMap: TJurisdictionMap;
  selectedFolderIds: string[];
  handleOpenAssociationDialog: THandleOpenAssociationDialog;
};

const TagItem: FC<TProps> = ({ tag, jurisdictionsMap, selectedFolderIds, handleOpenAssociationDialog }) => {
  const [showAllItems, setShowAllItems] = useState(false);

  // display the items relevant to the currently selected jurisdictions
  const filteredAssociatedItems = useMemo(() => {
    return tag.associatedItems.filter((associatedItem: TAssociatedItem) => {
      const jurisId = getJurisdictionId(associatedItem.item);
      if (!jurisId) return false;

      return selectedFolderIds.includes(jurisId);
    });
  }, [tag.associatedItems, selectedFolderIds]);

  const hasItems = filteredAssociatedItems.length > 0;

  const itemsToShow = showAllItems
    ? filteredAssociatedItems
    : filteredAssociatedItems.slice(0, SHOW_ASSOCIATED_FILES_DEFAULT_NUM);

  return (
    <div className="flex flex-col gap-2 items-start">
      <div className="flex flex-col gap-2">
        <TagBadge tag={tag} />
        {tag.description && <Body1>{tag.description}</Body1>}
      </div>

      {hasItems ? (
        <AssociatedItemsTable
          tag={tag}
          jurisdictionsMap={jurisdictionsMap}
          items={itemsToShow}
          handleOpenAssociationDialog={handleOpenAssociationDialog}
        />
      ) : (
        <AssociateButton onClick={() => handleOpenAssociationDialog.item(tag._id)} />
      )}

      {hasItems && filteredAssociatedItems.length > SHOW_ASSOCIATED_FILES_DEFAULT_NUM && (
        <Button
          appearance="transparent"
          size="small"
          aria-label="show more associated items"
          /*className={classes.showMore}*/
          onClick={(e) => {
            e.stopPropagation();
            setShowAllItems((prev) => !prev);
          }}
        >
          {showAllItems
            ? 'Show less'
            : `Show ${filteredAssociatedItems.length - SHOW_ASSOCIATED_FILES_DEFAULT_NUM} more`}
        </Button>
      )}
    </div>
  );
};

export default TagItem;
